import type { MedStato } from '../../api/types'
import { t } from '../../i18n/lingua'

/**
 * What the CENSO MED pages and windows share: the labels of the record
 * statuses, of the electrical classes and of where a model comes from.
 * Translated where they are declared (see `etichettaStato` in common.tsx).
 */

export const STATI_MED: MedStato[] = ['unregistered', 'in_use', 'spare', 'under_repair', 'out_of_service', 'decommissioned']

export function etichettaStatoMed(stato: string): string {
  const etichette: Record<MedStato, string> = {
    unregistered: t('Da registrare'),
    in_use: t('In uso'),
    spare: t('Di scorta'),
    under_repair: t('In riparazione'),
    out_of_service: t('Fuori servizio'),
    decommissioned: t('Dismesso'),
  }
  return etichette[stato as MedStato] ?? stato
}

export function BadgeStatoMed({ stato }: { stato: string }) {
  const tono: Record<string, string> = {
    unregistered: 'muted', in_use: 'ok', spare: 'info', under_repair: 'warn', out_of_service: 'error',
    decommissioned: 'muted',
  }
  return <span className={`badge badge--${tono[stato] ?? 'muted'}`}>{etichettaStatoMed(stato)}</span>
}

/** Where the exact model comes from, in words. */
export function fonteModello(fonte: string | null): string {
  if (!fonte) return ''
  if (fonte.startsWith('reference:')) return t('dall’inventario di riferimento ({fonte})', { fonte: fonte.slice('reference:'.length) })
  const etichette: Record<string, string> = {
    catalogue: t('dal nome del dispositivo, confrontato con il catalogo'),
    registry: t('dal numero di prodotto, nel registro del Ministero della Salute'),
    recognition: t('dal riconoscimento'),
    wire: t('dichiarato dal dispositivo sul filo (DICOM/HL7)'),
    manual: t('scritto a mano'),
    cmms: t('dal CMMS'),
  }
  return etichette[fonte] ?? fonte
}

/** CEI EN 62353 protection classes and applied parts, with what they mean. */
export function classiElettriche(): [string, string][] {
  return [
    ['I', t('Classe I: protezione con il conduttore di terra')],
    ['II', t('Classe II: doppio isolamento')],
    ['IP', t('Alimentazione interna (a batteria)')],
  ]
}

export function partiApplicate(): [string, string][] {
  return [
    ['B', t('B: nessun contatto diretto con il paziente')],
    ['BF', t('BF: a contatto con il paziente, isolata')],
    ['CF', t('CF: per l’applicazione diretta al cuore')],
  ]
}

/** The statuses of an asset in the register, in words. */
export function etichettaStatoCespite(stato: string): string {
  const e: Record<string, string> = {
    in_stock: t('In magazzino'), in_use: t('In servizio'), maintenance: t('In manutenzione'),
    reserved: t('Riservato'), retired: t('Dismesso'), disposed: t('Alienato'), lost: t('Non trovato'),
  }
  return e[stato] ?? stato
}
